import type { TranslationTree } from '../../types';

export const analytics: TranslationTree = {
  analytics: {
    dashboard: {
      title: 'Analytik',
      description:
        'Vergleichen Sie die Referenzen Ihrer Flotte, messen Sie ihren Produktionsanteil und identifizieren Sie die Kontexte mit den besten Leistungen.',
      breadcrumb: {
        analytics: 'Erweiterte Analysen',
      },
      sections: {
        performanceSummary: 'Leistungsübersicht',
        performanceSummaryDescription:
          'Gesamtbewertung und wichtige Leistungskennzahlen der Referenz.',
        keyMetrics: 'Wichtige Kennzahlen',
        keyMetricsDescription: 'Überblick über die Leistung der ausgewählten Referenz.',
        performanceAnalysis: 'Leistungsanalyse',
        performanceAnalysisDescription:
          'Vergleich mit anderen Referenzen und Prozesskonfiguration.',
        environmentalImpact: 'Umwelteinfluss',
        environmentalImpactDescription:
          'Vergleichende Leistungsanalyse nach Maschine, Material und Bediener:in.',
        detailedBreakdown: 'Detaillierte Aufschlüsselung',
        detailedBreakdownDescription: 'Zyklenverteilung, Maschinennutzung und Materialien.',
        portfolioTrends: 'Portfolio & Trends',
        portfolioTrendsDescription:
          'Referenzportfolio-Überblick und Entwicklung im Laufe der Zeit.',
      },
      controls: {
        referenceLabel: 'Werkzeugreferenz',
        lastUpdated: 'Zuletzt aktualisiert: {{date}}',
        pieceCount: '{{count}} Stück produziert',
      },
      summary: {
        uniqueTools: 'Einzigartige Werkzeuge',
        totalTraces: 'Gesamte Traces',
        ranking: 'Rangfolge',
        rankValue: '{{rank}} von {{total}}',
        noRanking: 'Nicht gerankt',
        avgTracesPerTool: 'Ø Spuren / Werkzeug',
      },
      keyIndicators: {
        title: 'Schlüsselindikatoren',
        description: 'Schnellübersicht der aggregierten Metriken für alle Traces dieser Referenz.',
        noData: 'Keine Daten verfügbar',
        noDataDescription:
          'Keine Traces für diese Referenz gefunden. Wählen Sie eine andere Referenz oder aktualisieren Sie die Daten.',
        totalDuration: 'Gesamtdauer',
        totalDurationDesc: 'Über {{count}} Traces',
        durationByPiece: 'Dauer pro Stück',
        durationByPieceDesc: 'Durchschnitt',
        numberOfPieces: 'Anzahl der Stücke',
        numberOfPiecesDesc: 'Produziert',
        volumeRemoved: 'Entferntes Volumen',
        volumeRemovedDesc: 'Bearbeitetes Material',
        distanceTraveled: 'Zurückgelegte Strecke',
        distanceTraveledDesc: 'Bearbeitung insgesamt',
        malround: 'Malround',
        malroundDesc: 'Durchschnitt',
      },
      globalPerformance: {
        title: 'Globale Leistung',
        description:
          'Nutzungsverteilung und Leistungsvergleich über alle Werkzeuge dieser Referenz.',
        usageDistribution: 'Nutzungsverteilung',
        performanceComparison: 'Leistungsvergleich',
        toolComparison: '{{count}} Werkzeug(e) verglichen',
        dimensions: {
          material: 'Material',
          machine: 'Maschine',
          lubrication: 'Schmierung',
          toolHolder: 'Werkzeughalter',
        },
        metrics: {
          duration: 'Gesamtdauer',
          pieces: 'Anzahl der Stücke',
          volume: 'Entferntes Volumen',
          distance: 'Zurückgelegte Strecke',
          malround: 'Rundlauf',
        },
      },
      complexCharts: {
        legend: {
          more: 'usw. …',
        },
        title: 'Erweiterte Diagramme',
        description:
          'Erstellen Sie benutzerdefinierte Diagramme mit mehrdimensionalen Filtern zur Datenanalyse.',
        addChart: 'Diagramm hinzufügen',
        exportConfig: 'Konfiguration exportieren',
        importConfig: 'Konfiguration importieren',
        saveAsDefault: 'Als Standard speichern',
        clearDefault: 'Standard löschen',
        exportSuccess: 'Konfiguration erfolgreich exportiert',
        importSuccess: 'Konfiguration erfolgreich importiert',
        saveSuccess: 'Konfiguration als Standard gespeichert',
        clearSuccess: 'Standardkonfiguration gelöscht',
        importError: 'Import fehlgeschlagen. Bitte überprüfen Sie das Dateiformat.',
        exportError: 'Konfiguration konnte nicht exportiert werden.',
        saveError: 'Konfiguration konnte nicht als Standard gespeichert werden.',
        clearError: 'Standardkonfiguration konnte nicht gelöscht werden.',
        example: 'Beispiel',
        removeChart: 'Diagramm entfernen',
        editTitle: 'Titel bearbeiten',
        showingTraces: '{{filtered}} von {{total}} Meldungen angezeigt',
        noData: 'Keine Daten verfügbar',
        noDataForConfig: 'Keine Daten für die ausgewählte Konfiguration verfügbar.',
        chartError: 'Fehler bei der Diagrammdarstellung',
        chartErrorDescription:
          'Beim Rendern dieses Diagramms ist ein unerwarteter Fehler aufgetreten.',
        chartErrorTryAgain: 'Erneut versuchen',
        filters: {
          title: 'Filter',
          mode: 'Modus',
          filterMode: 'Filtermodus:',
          modeLabel: 'Filtermodus',
          allTraces: 'ALLE MELDUNGEN',
          anyTrace: 'BELIEBIGE MELDUNG',
          clearAll: 'Alle löschen',
          machines: 'Maschinen',
          materials: 'Materialien',
          toolHolders: 'Werkzeughalter',
          lubrications: 'Schmierungen',
          selectMachines: 'Maschinen auswählen',
          selectMaterials: 'Materialien auswählen',
          selectToolHolders: 'Werkzeughalter auswählen',
          selectLubrications: 'Schmierungen auswählen',
          activeFilters: 'Aktive Filter',
          noFilters: 'Keine Filter angewendet',
          noMachines: 'Keine Maschinen',
          noMaterials: 'Keine Materialien',
          noToolHolders: 'Keine Werkzeughalter',
          noLubrications: 'Keine Schmierungen',
          machineLabel: 'Maschine:',
          materialLabel: 'Material:',
          holderLabel: 'Halter:',
          lubricationLabel: 'Schmierung:',
          addFilter: 'Filter hinzufügen',
          allData: 'Alle Daten werden angezeigt',
          minMaxError: 'min > max',
          filterCount: '{{count}} aktiv',
          sectionCategorical: 'Kategorisch',
          sectionNumeric: 'Numerischer Bereich',
          sectionDate: 'Datumsbereich',
          removeRule: 'Regel entfernen',
          negateRule: 'Regel umkehren',
          negateTitle: 'Negation umschalten (≠)',
          valuePlaceholder: 'Wert…',
          kindBadge: {
            categorical: 'KAT',
            numeric: 'NUM',
            date: 'DATUM',
          },
          operators: {
            in: 'ist',
            not_in: 'ist nicht',
            range: 'zwischen',
            gte: '≥',
            lte: '≤',
            date_range: 'zwischen',
            after: 'nach',
            before: 'vor',
          },
          dimensions: {
            machine: 'Maschine',
            material: 'Material',
            lubrication: 'Schmierung',
            toolHolder: 'Werkzeughalter',
            totalMachiningDuration: 'Gesamtdauer',
            pieceMachiningDuration: 'Dauer pro Teil',
            machinedVolume: 'Volumen',
            machinedDistance: 'Distanz',
            machinedPieces: 'Bearbeitete Teile',
            malround: 'Rundlauffehler',
            toolState: 'Werkzeugzustand',
            startedAt: 'Gestartet am',
            endedAt: 'Beendet am',
            vc: 'Schnittgeschwindigkeit (vc)',
            fz: 'Vorschub pro Zahn (fz)',
            ap: 'Axiale Zustellung (ap)',
            ae: 'Radiale Zustellung (ae)',
            operation: 'Operation',
            clampingType: 'Spannungsart',
            reference: 'Referenz',
          },
        },
        tooltip: {
          tool: 'Werkzeug',
          trace: 'Spur',
          traceIndex: 'Spur-Index',
          category: 'Kategorie',
          value: 'Wert',
          count: 'Anzahl',
          frequency: 'Häufigkeit',
          range: 'Bereich',
          aggregatedFrom: 'Aggregiert aus {{count}} Spuren',
          aggregatedFromTools: 'Aggregiert aus {{count}} Werkzeugen',
          ofTotal: '{{percent}}% der Gesamtmenge',
          ofData: '{{percent}}% der Daten',
          min: 'Min',
          max: 'Max',
          median: 'Median',
          mean: 'Mittelwert',
          q1: 'Q1',
          q3: 'Q3',
          outliers: 'Ausreißer',
          samples: 'Stichproben',
          reference: 'Referenz',
          toolCount: '{{count}} Werkzeug(e)',
          traceCount: '{{count}} Spur(en)',
          vc: 'Schnittgeschwindigkeit (vc)',
          fz: 'Vorschub pro Zahn (fz)',
          ap: 'Axiale Zustellung (ap)',
          ae: 'Radiale Zustellung (ae)',
          operation: 'Operation',
          clampingType: 'Spannungsart',
        },
        configuration: {
          title: 'Konfiguration',
          chartType: 'Diagrammtyp',
          xAxis: 'X-Achse',
          yAxis: 'Y-Achse',
          groupBy: 'Gruppieren nach',
          aggregation: 'Aggregation',
          aggregationLevel: 'Aggregationsebene',
          byTool: 'Nach Werkzeug',
          byTrace: 'Nach Spur',
          byReference: 'Nach Referenz',
          advancedOptions: 'Erweiterte Optionen',
          binCount: 'Anzahl der Klassen',
          bins: 'Klassen',
          bins5: '5 Klassen',
          bins10: '10 Klassen',
          bins20: '20 Klassen',
          bins50: '50 Klassen',
          showGridLines: 'Gitterlinien anzeigen',
          showDataLabels: 'Datenbeschriftungen anzeigen',
          showTrendLine: 'Trendlinie anzeigen',
          colorBy: 'Farbe nach',
          sortOrder: 'Sortierreihenfolge',
          ascending: 'Aufsteigend',
          descending: 'Absteigend',
          alphabetical: 'Alphabetisch',
          radarMode: 'Radar-Modus',
          radarMaxItems: 'Max. Elemente',
          radarModes: {
            categories: 'Kategorien vergleichen',
            metrics: 'Metriken vergleichen',
          },
          showOutliers: 'Ausreißer anzeigen',
          sortAscending: 'Aufsteigend',
          sortDescending: 'Absteigend',
          sortAlphabetical: 'Alphabetisch',
          types: {
            scatter: 'Streudiagramm',
            bar: 'Balkendiagramm',
            histogram: 'Histogramm',
            pie: 'Kreisdiagramm',
            radar: 'Radardiagramm',
            boxplot: 'Boxplot',
          },
          metrics: {
            totalMachiningDuration: 'Gesamtdauer',
            pieceMachiningDuration: 'Dauer pro Stück',
            machinedPieces: 'Anzahl der Stücke',
            machinedVolume: 'Entferntes Volumen',
            machinedDistance: 'Zurückgelegte Strecke',
            durationByPiece: 'Dauer pro Stück',
            numberOfPieces: 'Anzahl der Stücke',
            volumeRemoved: 'Entferntes Volumen',
            distanceTraveled: 'Zurückgelegte Strecke',
            malround: 'Rundlauf',
            machine: 'Maschine',
            material: 'Material',
            toolHolder: 'Werkzeughalter',
            lubrication: 'Schmierung',
            operator: 'Bediener',
            toolId: 'Werkzeug-ID',
            traceId: 'Spur-ID',
            reference: 'Referenz',
            toolState: 'Werkzeugzustand',
            traceCount: 'Anzahl der Meldungen',
            vc: 'Schnittgeschwindigkeit (Vc)',
            fz: 'Vorschub pro Zahn (fz)',
            ap: 'Axiale Schnitttiefe (ap)',
            ae: 'Radiale Schnitttiefe (ae)',
            operation: 'Operation',
            clampingType: 'Spannart',
          },
          noData: 'Keine Daten für die ausgewählte Konfiguration verfügbar',
          aggregations: {
            sum: 'Summe',
            mean: 'Durchschnitt',
            avg: 'Durchschnitt',
            median: 'Median',
            min: 'Minimum',
            max: 'Maximum',
            count: 'Anzahl',
            p90: '90. Perzentil',
            p95: '95. Perzentil',
          },
        },
        defaults: {
          xAxisLabel: 'X-Achse',
          yAxisLabel: 'Y-Achse',
          categoryLabel: 'Kategorie',
          valueLabel: 'Wert',
          traceIndexLabel: 'Spur-Index',
          frequency: 'Häufigkeit',
          frequencyLabel: 'Häufigkeit (Anzahl)',
          unknown: 'Unbekannt',
        },
        axis: {
          traceIndex: 'Spur-Index',
          traceNumber: 'Spur {{number}}',
        },
        widget: {
          viewOnly: 'Nur Ansicht',
        },
        export: {
          button: 'Als PNG exportieren',
          success: 'Diagramm erfolgreich exportiert',
          error: 'Fehler beim Export',
        },
        stale: {
          code: 'WARN_STALE_METRIC',
          title: 'Diagramm benötigt Neukonfiguration',
          editConfig: 'Konfiguration bearbeiten',
          dismiss: 'Verwerfen',
        },
        emptyState: {
          filterCode: 'ERR_FILTER_NO_MATCH',
          filterTitle: 'Keine Traces gefunden',
          filterBody: 'Aktive Filter ergaben 0 Ergebnisse. Versuchen Sie, die Einschränkungen zu lockern.',
          noDataCode: 'AWAIT_DATA',
          noDataTitle: 'Keine Daten für diesen Zeitraum',
          noDataBody:
            'Keine Traces für die ausgewählte Referenz und den Datumsbereich verfügbar.',
          resetFilters: 'Filter zurücksetzen',
          editConfig: 'Konfiguration bearbeiten',
          configure: 'Diagramm konfigurieren',
        },
        removeDialog: {
          title: 'Diagramm entfernen?',
          subtitle: 'Destruktiv · Rückgängig verfügbar (5s)',
          body: '{{title}} wird von diesem Dashboard entfernt.',
          confirm: 'Diagramm entfernen',
          cancel: 'Abbrechen',
        },
        clearDefaultDialog: {
          title: 'Gespeicherte Standardkonfiguration löschen?',
          subtitle: 'Destruktiv · Kann nicht rückgängig gemacht werden',
          body: 'Ihr gespeichertes Dashboard-Layout wird gelöscht.',
          confirm: 'Standard löschen',
          cancel: 'Abbrechen',
        },
        undoRemove: {
          removed: '{{title}} entfernt',
          undo: 'Rückgängig',
          dismiss: 'Verwerfen',
        },
        dragHandle: 'Zum Neuanordnen ziehen',
        newChart: 'Neues Diagramm',
        chartNumber: 'Diagramm {{number}}',
        layoutLabel: 'Diagrammgröße',
        layout: {
          sm: 'Klein',
          md: 'Mittel',
          lg: 'Groß',
          full: 'Volle Breite',
        },
      },
      shortcuts: {
        refresh: 'Drücken Sie R zum Aktualisieren',
      },
      actions: {
        refresh: 'Daten aktualisieren',
        refreshing: 'Aktualisierung…',
        compareReferences: 'Referenzen vergleichen',
      },
      filters: {
        title: 'Filter',
        clearAll: 'Filter zurücksetzen',
        machine: {
          label: 'Maschine',
          placeholder: 'Maschine auswählen',
          all: 'Alle Maschinen',
        },
        lubrication: {
          label: 'Schmierung',
          placeholder: 'Schmierung auswählen',
          all: 'Alle Schmierungen',
        },
        material: {
          label: 'Material',
          placeholder: 'Material auswählen',
          all: 'Alle Materialien',
        },
      },
      common: {
        minutes: '{{value}} min',
        noData: 'Keine Daten verfügbar',
        notSpecified: 'Nicht angegeben',
      },
      samples: {
        fallback: 'Keine Stichprobe verfügbar',
        traces: '{{count}} analysierte Meldungen',
        tracesFiltered: '{{filtered}} analysierte Meldungen ({{total}} insgesamt)',
        occurrences: '{{count}} Vorkommen',
        cycles: '{{count}} Zyklen',
        trend: '{{count}} Perioden',
        references: '{{count}} verglichene Referenzen',
      },
      error: {
        loadFailure:
          'Analysedaten konnten nicht geladen werden. Es werden simulierte Werte angezeigt.',
        title: 'Analysedaten konnten nicht abgerufen werden',
        detailsTitle: 'Technische Details',
        detailName: 'Typ: {{value}}',
        detailCode: 'Code: {{value}}',
        detailMessage: 'Nachricht: {{value}}',
        detailTimestamp: 'Zeitstempel: {{value}}',
        detailsFallback: 'Keine zusätzlichen Details verfügbar.',
        retry: 'Erneut versuchen',
        noRef: 'Keine Referenz verfügbar. Bitte prüfen Sie, ob Werkzeuge erfasst wurden.',
        unknown: 'Ein unbekannter Fehler ist aufgetreten.',
      },
      stats: {
        totalPieces: {
          title: 'Produzierte Teile',
          helper: 'Basierend auf {{count}} Meldungen.',
          tooltip:
            'Gesamtzahl der mit dieser Werkzeugreferenz bearbeiteten Teile gemäß erfassten Meldungen.',
        },
        cycleEfficiency: {
          title: 'Zyklus-Effizienz',
          helper: 'Bearbeitete Zeit vs. gesamte Zyklusdauer',
          tooltip:
            'Verhältnis zwischen tatsächlicher Bearbeitungszeit und gesamter Zyklusdauer, ausgedrückt in Prozent. Eine hohe Rate zeigt eine bessere Maschinenauslastung.',
        },
        averageCycle: {
          title: 'Durchschnittliche Zykluszeit',
          helper: 'Durchschnittliche Bearbeitungsdauer pro Meldung',
          tooltip:
            'Durchschnittliche Zeit zur Fertigstellung eines Bearbeitungszyklus mit diesem Werkzeug. Hilft bei der Schätzung von Produktionszeiten.',
        },
        malround: {
          title: 'Durchschnittlicher Rundlauf',
          helper: 'Oberflächenkennwert (niedriger = besser)',
          tooltip:
            'Maß für die Rundheit des bearbeiteten Teils. Je niedriger der Wert, desto besser die Oberflächenqualität.',
        },
        downtime: {
          title: 'Stillstandsrate',
          helper: 'Vorfälle pro zehn aktuelle Meldungen',
          value: '{{value}} / 10 Meldungen',
          tooltip:
            'Anzahl der Vorfälle oder Werkzeugwechsel pro zehn Meldungen. Eine hohe Rate kann auf Wartungsbedarf oder Prozessprobleme hinweisen.',
        },
        operatorCoverage: {
          title: 'Operatorenabdeckung',
          empty: '—',
          valueSingular: '{{count}} Bediener:in',
          valuePlural: '{{count}} Bediener:innen',
          helperEmpty: 'Kein führender Bediener erfasst.',
          helperWithShare: 'Hauptbediener: {{operator}} ({{share}}%)',
          helperWithoutShare: 'Hauptbediener: {{operator}}',
          tooltip:
            'Anzahl verschiedener Bediener, die diese Referenz verwendet haben, und Identifikation des Hauptbedieners. Hilft bei der Verfolgung der Teamvielseitigkeit.',
        },
        totalVolume: {
          title: 'Gesamt bearbeitetes Volumen',
          helper: 'Kumulatives Volumen über alle Meldungen',
          value: '{{value}} cm³',
          tooltip:
            'Gesamtvolumen des mit dieser Werkzeugreferenz entfernten Materials. Wichtiger Indikator für Werkzeugverschleiß und -belastung.',
        },
        averageVolume: {
          title: 'Durchschnittliches Volumen pro Meldung',
          helper: 'Durchschnittliches Volumen pro Bearbeitungszyklus',
          value: '{{value}} cm³',
          tooltip:
            'Durchschnittliches Volumen des pro Meldung entfernten Materials. Hilft bei der Schätzung der Belastung pro Zyklus.',
        },
        totalDistance: {
          title: 'Gesamt zurückgelegte Strecke',
          helper: 'Kumulative Strecke über alle Meldungen',
          value: '{{value}} mm',
          tooltip:
            'Gesamt vom Werkzeug während der Bearbeitung zurückgelegte Strecke. Wichtiger Faktor zur Vorhersage des Werkzeugverschleißes.',
        },
        averageDistance: {
          title: 'Durchschnittliche Strecke pro Meldung',
          helper: 'Durchschnittliche Strecke pro Bearbeitungszyklus',
          value: '{{value}} mm',
          tooltip:
            'Durchschnittliche vom Werkzeug pro Meldung zurückgelegte Strecke. Hilft bei der Schätzung der Beanspruchung pro Zyklus.',
        },
      },
      comparison: {
        title: 'Referenzvergleich',
        description: 'Platzierung dieser Referenz im Vergleich zum restlichen Portfolio.',
        currentBadge: 'Aktuell',
        rank: 'Platz {{rank}} von {{total}} erfassten Referenzen.',
        rankUnavailable: 'Ranking der Referenz nicht verfügbar.',
      },
      process: {
        title: 'Prozesskonfiguration',
        description: 'Häufigste Konfigurationselemente der letzten Meldungen.',
        lubrication: 'Schmierung',
        holder: 'Werkzeughalter',
        clamping: 'Spannung',
        notProvided: 'Nicht angegeben',
        brandVariety: '{{count}} Marke(n)',
        throughputShare: 'Produktionsanteil',
        throughputDetail: '{{share}} der Gesamtteile',
      },
      cycles: {
        title: 'Zyklusdauer-Verteilung',
        description:
          'Analysieren Sie die Streuung der Zyklen, um Anomalien und Wartungsbedarf zu erkennen.',
        emptyLoading: 'Zyklusdaten werden geladen…',
        xLabel: 'Zyklusdauer [min]',
        yLabel: 'Anzahl der Bearbeitungszyklen',
        emptyData: 'Keine Zyklusdauer für diese Referenz verfügbar.',
      },
      machines: {
        title: 'Maschinenverteilung',
        description: 'Maschinen, die dieser Referenz am häufigsten zugeordnet sind.',
        noActivity: 'Keine Maschinenaktivität für diese Referenz erfasst.',
        topInfo: '{{machine}}: {{share}} % der aktuellen Meldungen.',
        emptyDistribution: 'Keine Maschinenverteilung verfügbar.',
        empty: 'Keine Maschinendaten verfügbar.',
      },
      operators: {
        title: 'Operatorenverteilung',
        description: 'Häufigste Bediener:innen für diese Referenz.',
        listEmpty: 'Keine Operatorendaten für diese Referenz erfasst.',
        empty: 'Keine Operatorendaten verfügbar.',
      },
      materials: {
        title: 'Materialverteilung',
        description: 'Am häufigsten bearbeitete Materialien mit dieser Referenz.',
        noInfo: 'Keine Materialinformationen für diese Referenz verfügbar.',
        infoSingular: '{{count}} Material wurde kürzlich bearbeitet.',
        infoPlural: '{{count}} Materialien wurden kürzlich bearbeitet.',
        emptyDistribution: 'Keine Materialverteilung verfügbar.',
        empty: 'Keine Materialdaten verfügbar.',
      },
      changeReasons: {
        title: 'Interventionsgründe',
        description: 'Häufigste Gründe bei Änderungen des Werkzeugstatus.',
        empty: 'Kein Grund erfasst.',
        listEmpty: 'Bislang kein Wechselgrund erfasst.',
        downtimeRate: 'Stillstandsrate: {{rate}}',
      },
      portfolio: {
        title: 'Referenzportfolio',
        description: 'Produktionsanteil je Referenz innerhalb der Organisation.',
      },
      empty: {
        noComparison: 'Keine Vergleichsdaten verfügbar.',
        selectReference: 'Wählen Sie eine Referenz aus, um die Analysen anzuzeigen.',
      },
      trend: {
        title: 'Produktionsverlauf',
        description: 'Verteilung von produktiver Zeit und Stillständen (in Minuten).',
        producedSeries: 'Produktive Zeit (Min)',
        downtimeSeries: 'Stillstandszeit (Min)',
        empty: 'Nicht genügend Daten für den Verlauf.',
      },
      export: {
        downloadPNG: 'Als PNG herunterladen',
        downloadCSV: 'Daten exportieren (CSV)',
        share: 'Teilen',
        shareText: 'Sehen Sie sich dieses Diagramm an:',
      },
      insights: {
        title: 'Erkenntnisse und Empfehlungen',
        description: 'Automatisch identifizierte Schlüsselpunkte aus Ihren Daten.',
        highEfficiency: 'Ausgezeichnete Zykluseffizienz von {{efficiency}}% - Sehr gute Leistung!',
        lowEfficiency:
          'Zykluseffizienz von {{efficiency}}% - Verbesserungspotenzial bei Qualität oder Konfiguration.',
        topPerformer: 'Diese Referenz ist Nr. 1 im Produktionsvolumen - Spitzenreiter!',
        goodRank: 'Diese Referenz liegt in den Top {{rank}} - Gute relative Leistung.',
        highDowntime:
          '{{downtime}} Vorfälle pro 10 Meldungen - Hohe Ausfallrate, wiederkehrende Ursachen prüfen.',
        noDowntime: 'Keine Vorfälle erkannt - Stabiler und zuverlässiger Prozess.',
        improvingTrend: 'Produktion vor kurzem um {{change}}% gestiegen - Positiver Trend!',
        decliningTrend: 'Produktion vor kurzem um {{change}}% gesunken - Trend zu beobachten.',
        highOperatorCoverage:
          '{{count}} verschiedene Bediener:innen verwenden diese Referenz - Breite Akzeptanz.',
        singleOperator:
          'Nur von {{operator}} verwendet - Schulung anderer Bediener:innen in Betracht ziehen.',
        singleMachine: 'Nur auf {{machine}} verwendet - Auf eine Maschine beschränkt.',
        lowDataVolume:
          'Begrenzte Daten verfügbar - Anzahl der Meldungen für zuverlässigere Analysen erhöhen.',
        priority: {
          critical: 'Kritisch',
          attention: 'Achtung',
          optimization: 'Optimierung',
        },
        category: {
          performance: 'Leistung',
          trend: 'Trend',
          anomaly: 'Anomalie',
          tip: 'Tipp',
        },
      },
      performanceSummary: {
        globalScore: 'Gesamtbewertung',
        classification: {
          excellent: 'Ausgezeichnet',
          good: 'Gut',
          average: 'Durchschnittlich',
          'needs-improvement': 'Verbesserungsbedarf',
        },
        efficiency: 'Effizienz',
        quality: 'Qualität',
        reliability: 'Zuverlässigkeit',
        aboveAverage: 'Überdurchschnittlich',
        belowAverage: 'Unterdurchschnittlich',
        excellentQuality: 'Ausgezeichnete Qualität',
        improvableQuality: 'Verbesserungsfähige Qualität',
        downtimePer10: 'Vorfälle pro 10 Meldungen',
        ranking: 'Rang',
        productionShare: 'Produktionsanteil',
      },
      environmentalImpact: {
        machineAnalysis: 'Maschinenanalyse',
        materialAnalysis: 'Materialanalyse',
        operatorAnalysis: 'Bediener:innen-Analyse',
        malround: 'Malround',
        efficiency: 'Effizienz',
        incidents: 'Vorfälle',
        traces: 'Meldungen',
        pieces: 'Stücke',
        noData: 'Keine Daten verfügbar',
        optimalConfig: 'Optimale Konfiguration identifiziert',
        optimalConfigDescription:
          'Maschinen-Material-Kombination mit der besten beobachteten Leistung.',
        machine: 'Maschine',
        material: 'Material',
      },
      subtitle: 'Leistungsanalyse nach Werkzeugreferenz',
      managepanels: 'Panels verwalten',
      classicView: 'Klassische Ansicht',
      refresh: 'Aktualisieren',
      loading: 'Werkzeuge werden geladen…',
      ref: {
        label: 'Referenz',
        avgPieces: 'Ø Stk.',
        tools: 'Werkzeuge',
        states: {
          new: 'neu',
          active: 'aktiv',
          worn: 'verschlissen',
          broken: 'gebrochen',
          broken_early: 'Frühbruch',
          unknown: 'unbekannt',
        },
      },
      panel: {
        noselection: {
          title: 'Keine Panels ausgewählt',
          desc: 'Klicken Sie auf Panels verwalten, um Panels zum Dashboard hinzuzufügen.',
        },
        lives: {
          name: 'Standzeiten',
          desc: 'Produzierte Stücke pro Werkzeug, absteigend sortiert.',
        },
        anomalies: {
          name: 'Anomalien',
          desc: 'Werkzeuge mit deutlich unterdurchschnittlicher Stückzahl.',
        },
        machine: {
          name: 'Nach Maschine',
          desc: 'Durchschnittliche Stückzahl nach Maschine.',
        },
        operator: {
          name: 'Nach Bediener',
          desc: 'Durchschnittliche Stückzahl nach Bediener.',
        },
        material: {
          name: 'Nach Material',
          desc: 'Durchschnittliche Stückzahl nach Material.',
        },
        vc: {
          name: 'Schnittgeschwindigkeit',
          desc: 'Streuung Standzeit vs. Schnittgeschwindigkeit (Vc).',
        },
        fz: {
          name: 'Vorschub je Zahn',
          desc: 'Streuung Standzeit vs. Vorschub je Zahn (fz).',
        },
        ap: {
          name: 'Axiale Schnitttiefe',
          desc: 'Streuung Standzeit vs. axiale Schnitttiefe (ap).',
        },
      },
      drawer: {
        title: 'Panels verwalten',
        group: {
          overview: 'Übersicht',
          context: 'Kontextaufschlüsselung',
          params: 'Parameteranalyse',
        },
      },
      lives: {
        columns: {
          tool: 'Werkzeug',
          pieces: 'Produzierte Stücke',
          machine: 'Maschine',
        },
        legend: {
          new: 'Neu',
          active: 'Aktiv',
          worn: 'Verschlissen',
          broken: 'Gebrochen',
        },
        unit: {
          pieces: 'Stk.',
        },
      },
      anomalies: {
        col: {
          tool: 'Werkzeug',
          pieces: 'Stücke',
          vsAvg: 'vs Ø',
          machine: 'Maschine',
          operator: 'Bediener',
          material: 'Material',
          vc: 'Vc',
          status: 'Status',
        },
        badge: {
          broken: 'Gebrochen',
          investigate: 'Prüfen',
        },
      },
      scatter: {
        nodata: 'Keine Daten für die gewählte Achse verfügbar.',
        pieces: 'Teile',
        axisLabels: {
          vc: 'Schnittgeschwindigkeit (Vc)',
          fz: 'Vorschub je Zahn (fz)',
          ap: 'Schnittiefe (ap)',
        },
        note: {
          vc: 'Hohe Vc (>200 m/min) kann die Standzeit verkürzen. Optimalbereich hervorgehoben.',
          fz: 'Optimaler fz-Wert balanciert Produktivität und Werkzeugverschleiß.',
          ap: 'Tiefere Schnitte erhöhen die Last — Standzeit sorgfältig überwachen.',
        },
      },
      grouped: {
        columns: {
          machine: 'Maschine',
          operator: 'Bediener',
          material: 'Werkstoff',
          avgPieces: 'Ø Stücke / Werkzeug',
          tools: 'Werkz.',
        },
        note: {
          machine: '{{top}} erzielt {{ratio}}× mehr Stücke als {{bottom}}.',
          operator: '{{top}} produziert {{ratio}}× mehr Stücke als {{bottom}}.',
          material: '{{top}} ermöglicht {{ratio}}× mehr Stücke als {{bottom}}.',
        },
      },
      kpi: {
        avgLife: 'Ø Werkzeugstandzeit',
        avgLifeSub: 'max: {{best}} · min: {{worst}}',
        totalPieces: 'Teile gesamt',
        totalPiecesSub: 'über {{n}} Werkzeuge',
        totalTime: 'Gesamtbearbeitungszeit',
        totalTimeSub: 'Ø {{n}} min / Werkzeug',
        avgTimePerPiece: 'Ø Zeit / Teil',
        totalVolume: 'Zerspantes Volumen',
        totalVolumeSub: 'Ø {{n}} cm³ / Werkzeug',
        avgMalround: 'Ø Rundlauffehler',
        avgMalroundRange: 'Bereich {{min}} – {{max}}',
        unit: {
          piecesPerTool: 'Teile / Werkzeug',
          pieces: 'Teile',
          minutes: 'Minuten',
          secPerPiece: 's / Teil',
          cm3: 'cm³ gesamt',
          um: 'µm',
        },
      },
    },
    classic: {
      backLink: '← Neue Analyseansicht',
    },
    comparison: {
      breadcrumb: {
        analytics: 'Erweiterte Analysen',
        comparison: 'Referenzvergleich',
      },
      selector: {
        title: 'Referenzauswahl',
        description:
          'Wählen Sie eine Basisreferenz und vergleichen Sie sie mit anderen, um Leistungskennzahlen zu analysieren.',
        baseReference: {
          label: 'Basisreferenz',
          badge: 'Basis',
          placeholder: 'Basisreferenz auswählen...',
          helper: 'Die Basisreferenz dient als Vergleichspunkt für alle anderen.',
        },
        comparisonReferences: {
          label: 'Zu vergleichende Referenzen',
          count: '{{selected}}/{{total}} ausgewählt',
          helper:
            'Klicken Sie auf Referenzen, um sie zum Vergleich hinzuzufügen oder zu entfernen.',
        },
        summary: {
          title: '{{count}} Referenz(en) ausgewählt',
        },
        empty: 'Keine Referenzen für den Vergleich verfügbar.',
      },
      layout: {
        pill: 'Referenzvergleich',
        title: 'Leistungsfähigkeit von Referenzen vergleichen',
        subtitle:
          'Analysieren Sie zentrale Kennzahlen, um den Einfluss jeder Referenz auf Produktion, Qualität und Abläufe zu verstehen.',
        controls: {
          primaryLabel: 'Hauptreferenz',
          baselineBadge: 'Basisreferenz',
          comparisonLabel: 'Zu vergleichende Referenzen',
          comparisonCount: '{{selected}}/{{total}} ausgewählt',
          baselineIndicator: '(Basis)',
          selectPlaceholder: 'Referenz auswählen...',
          multiHelper:
            'Wählen Sie mindestens eine Referenz für den Vergleich. Der erste Eintrag dient als Basis.',
          refresh: 'Vergleich aktualisieren',
          refreshing: 'Aktualisierung…',
        },
        filters: {
          title: 'Filter',
          machine: {
            label: 'Maschine',
            placeholder: 'Alle Maschinen',
            all: 'Alle Maschinen',
          },
          lubrication: {
            label: 'Schmierung',
            placeholder: 'Alle Schmierungen',
            all: 'Alle Schmierungen',
          },
          material: {
            label: 'Material',
            placeholder: 'Alle Materialien',
            all: 'Alle Materialien',
          },
          operation: {
            label: 'Operation',
            placeholder: 'Alle Operationen',
            all: 'Alle Operationen',
          },
          clear: 'Zurücksetzen',
          clearAll: 'Filter zurücksetzen',
        },
        table: {
          title: 'Metrikvergleich',
          subtitle: '{{count}} Referenz(en) verglichen',
          metric: 'Metrik',
          baseline: 'Baseline',
          totalDuration: 'Durchschnittliche Gesamtdauer',
          totalDurationHelper: 'Durchschnittliche Zyklusdauer pro Werkzeug',
          numberOfParts: 'Anzahl der Teile',
          numberOfPartsHelper: 'Gesamt produzierte Teile',
          volumeRemoved: 'Entferntes Volumen',
          volumeRemovedHelper: 'Gesamtes entferntes Materialvolumen',
          distanceTravelled: 'Zurückgelegte Strecke',
          distanceTravelledHelper: 'Vom Werkzeug zurückgelegte Gesamtstrecke',
          malround: 'Durchschnittlicher Malround',
          malroundHelper: 'Durchschnittlicher Rundheitsfehler',
        },
        metrics: {
          referenceTitle: 'Produktion – {{reference}}',
          piecesValue: '{{count}} Teil(e)',
          traceHelper: '{{count}} Meldung(en) analysiert',
          averageCycle: {
            title: 'Durchschnittliche Zykluszeit – {{reference}}',
            helper: 'Durchschnittliche Minuten pro Meldung.',
            value: '{{value}} Min.',
          },
          cycleEfficiency: {
            title: 'Zyklus-Effizienz – {{reference}}',
            helper: 'Anteil produktiver Bearbeitung an der Gesamtzeit.',
            value: '{{value}} %',
          },
          downtime: {
            title: 'Stillstandsrate – {{reference}}',
            helper: 'Vorfälle je zehn aktuelle Meldungen.',
            value: '{{value}} / 10 Meldungen',
          },
          operatorCoverage: {
            title: 'Operatorenabdeckung – {{reference}}',
            helper: 'Dominierender Operator und Anzahl beteiligter Personen.',
            empty: 'Keine Operatorendaten verfügbar.',
            valueWithShare: '{{count}} Operator(en). Leader: {{operator}} ({{share}}%).',
            valueWithoutShare: '{{count}} Operator(en). Leader: {{operator}}.',
            valueWithoutLeader: '{{count}} Operator(en) erfasst.',
          },
          totalVolume: {
            title: 'Gesamt bearbeitetes Volumen – {{reference}}',
            helper: 'Kumulatives Volumen über alle Meldungen.',
            value: '{{value}} cm³',
          },
          averageVolume: {
            title: 'Durchschnittliches Volumen – {{reference}}',
            helper: 'Durchschnittliches Volumen pro Bearbeitungszyklus.',
            value: '{{value}} cm³',
          },
          totalDistance: {
            title: 'Gesamt zurückgelegte Strecke – {{reference}}',
            helper: 'Kumulative Strecke über alle Meldungen.',
            value: '{{value}} mm',
          },
          averageDistance: {
            title: 'Durchschnittliche Strecke – {{reference}}',
            helper: 'Durchschnittliche Strecke pro Bearbeitungszyklus.',
            value: '{{value}} mm',
          },
        },
        kpi: {
          sectionTitle: 'KPI-Vergleich',
          sectionTitleFallback: 'Metriken nach Referenz',
          labels: {
            baseline: 'Referenz',
            comparison: 'Vergleich',
          },
          cycleDuration: {
            title: 'Durchschnittliche Zyklusdauer',
            helper: 'Durchschnittliche Zeit pro Produktionszyklus',
          },
          cycleEfficiency: {
            title: 'Zykluseffizienz',
            helper: 'Verhältnis zwischen produktiver Bearbeitungszeit und Gesamtzeit',
          },
          downtime: {
            title: 'Stillstand pro 10 Spuren',
            helper: 'Durchschnittliche Anzahl von Vorfällen pro 10 Spuren',
          },
          malround: {
            title: 'Durchschnittliche Rundheit',
            helper: 'Durchschnittlicher Rundheitsfehler',
          },
          pieces: {
            title: 'Produzierte Teile',
            helper: 'Gesamtzahl der bearbeiteten Teile',
          },
        },
        chartTitles: {
          productionTrend: 'Produktionsverlauf im Vergleich',
          cycleDistribution: 'Verteilung der Zyklusdauer',
          machineContribution: 'Maschinenanteil',
          operatorMix: 'Operator-Mix',
        },
        charts: {
          common: {
            minutes: '{{value}} Min',
            pieces: '{{value}} Teil(e)',
          },
          legend: {
            showMore: '{{count}} weitere anzeigen',
            showLess: 'Weniger anzeigen',
            topItems: 'Top {{count}} Elemente',
            allItems: 'Alle {{count}} Elemente',
          },
          trend: {
            description:
              'Verfolgen Sie produktive Zeit und Stillstand für jede ausgewählte Referenz.',
            legendProduced: 'Produktive Minuten — {{reference}}',
            legendDowntime: 'Stillstandsminuten — {{reference}}',
            empty: 'Keine verwertbare Trendkurve für diese Auswahl.',
          },
          cycle: {
            description:
              'Analysieren Sie die Verteilung der Zykluszeiten, um Unterschiede zu erkennen.',
            tabLabel: 'Referenz {{reference}}',
            xLabel: 'Zykluszeit (Min)',
            yLabel: 'Anzahl Messpunkte',
            empty: 'Für diese Referenz wurden keine Zykluszeiten erfasst.',
            emptyAll: 'Für die Auswahl sind keine Zykluszeiten verfügbar.',
          },
          machine: {
            description:
              'Vergleichen Sie den Maschinenbeitrag in produzierten Teilen über die Referenzen.',
            legend: 'Maschine — {{reference}}',
            empty: 'Keine Maschinendaten für diese Auswahl verfügbar.',
            unknown: 'Maschine nicht angegeben',
          },
          operator: {
            description: 'Ermitteln Sie die aktivsten Bediener je Vergleichsreferenz.',
            tabLabel: 'Referenz {{reference}}',
            empty: 'Keine Bedienerbeiträge verfügbar.',
            unknown: 'Bediener nicht angegeben',
          },
        },
        trend: {
          pieces: 'Stücke',
          cycleTime: 'Zykluszeit',
          piecesLabel: 'Anzahl der Stücke',
          cycleTimeLabel: 'Durchschnittliche Dauer (Min)',
          noData: 'Für diesen Zeitraum sind keine Trenddaten verfügbar.',
        },
        distribution: {
          mean: 'Mittelwert',
          meanLabel: 'Mittelw. {{reference}}',
          traces: 'Meldungen',
        },
        contribution: {
          piecesValue: '{{value}} Teil(e)',
          noData: 'Keine Beitragsdaten verfügbar.',
        },
        qualityDowntime: {
          malround: 'Malrund {{reference}}',
          downtime: 'Ausfallzeit {{reference}}',
          malroundLabel: 'Durchschn. Malrund',
          downtimeLabel: 'Vorfälle / 10 Meldungen',
          threshold: 'Schwellenwert',
          noValue: 'N/V',
          noData: 'Keine Qualitäts- oder Ausfallzeitdaten verfügbar.',
        },
        summary: {
          title: 'Zusammenfassung des Vergleichs',
          description:
            '{{count}} Referenz(en), {{totalTraces}} Meldung(en) und {{totalPieces}} Teil(e) in dieser Auswahl.',
        },
        state: {
          loading: 'Vergleichsdaten werden geladen…',
          empty: 'Für diese Auswahl sind keine Vergleichsdaten verfügbar.',
          emptyShort: 'Für diese Auswahl stehen keine Kennzahlen zur Verfügung.',
          noReferences: 'Derzeit wurden keine aktiven Referenzen gefunden.',
          errorTitle: 'Vergleich konnte nicht geladen werden',
          errorDescription:
            'Das Abrufen der Live-Daten ist fehlgeschlagen. Es werden beispielhafte Daten angezeigt, bis ein neuer Versuch startet.',
          usingSample:
            'Zur Orientierung werden Beispieldaten angezeigt. Aktualisieren Sie die Seite, um die Synchronisierung erneut zu starten.',
          errorDetailsTitle: 'Technische Details',
          errorDetailMessage: 'Nachricht: {{value}}',
          errorDetailCode: 'Code: {{value}}',
          errorDetailName: 'Typ: {{value}}',
          errorDetailTimestamp: 'Zeitstempel: {{value}}',
        },
      },
      performance: {
        title: 'Referenz-Leistungskennzahlen',
        description:
          'Vergleichen Sie durchschnittliche Kennzahlen pro Werkzeug über ausgewählte Referenzen hinweg.',
        meanDuration: {
          title: 'Mittlere Gesamtdauer',
          yAxisLabel: 'Dauer (min)',
          tooltip: 'Durchschnittliche Dauer',
        },
        meanPieces: {
          title: 'Mittlere Stückzahl',
          yAxisLabel: 'Stücke',
          tooltip: 'Durchschnittliche Stücke',
        },
        meanVolume: {
          title: 'Mittleres entferntes Volumen',
          yAxisLabel: 'Volumen (cm³)',
          tooltip: 'Durchschnittliches Volumen',
        },
        meanMalround: {
          title: 'Mittlerer Rundlauf',
          yAxisLabel: 'Rundlauf (µm)',
          tooltip: 'Durchschnittlicher Rundlauf',
        },
      },
      distribution: {
        title: 'Werkzeugleistungsverteilung',
        description:
          'Analysieren Sie die Verteilung der Werkzeugleistungskennzahlen über die ausgewählten Referenzen hinweg.',
        duration: {
          title: 'Dauerverteilung',
          yAxisLabel: 'Dauer',
        },
        pieces: {
          title: 'Stückzahlverteilung',
          yAxisLabel: 'Stücke',
        },
        volume: {
          title: 'Verteilung des entfernten Volumens',
          yAxisLabel: 'Volumen',
        },
        malround: {
          title: 'Rundlaufverteilung',
          yAxisLabel: 'Rundlauf (µm)',
        },
      },
    },
    charts: {
      legend: {
        showMore: '{{count}} weitere anzeigen',
        showLess: 'Weniger anzeigen',
        topItems: 'Top {{count}} Elemente',
        allItems: 'Alle {{count}} Elemente',
      },
      errors: {
        invalidConfig: 'Ungültige Diagrammkonfiguration',
        noData: 'Keine Daten verfügbar',
        unknownType: 'Unbekannter Diagrammtyp',
      },
    },
    chartError: {
      title: 'Fehler beim Rendern des Diagramms',
      unexpected: 'Ein unerwarteter Fehler ist aufgetreten',
      tryAgain: 'Erneut versuchen',
      stackTrace: 'Stacktrace',
    },
  },
};
